module.exports = __webpack_public_path__ + "media/img/bg-card-a44edb2d3c4434fce53ef5bfb0cef15a.png";